import { useState, useEffect, useContext } from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { isEmpty } from "lodash";
import {
  MdOutlineAccessTime,
  MdOutlinePowerSettingsNew,
  MdOutlinePieChart,
  MdOutlineHistoryEdu,
  MdOutlineContactPhone,
} from "react-icons/md";
import {
  HiOutlineShoppingBag,
  HiOutlineUserGroup,
  HiOutlineNewspaper,
  HiExclamation,
} from "react-icons/hi";
import { HiOutlineHome } from "react-icons/hi";
import { logo } from "../../../assets";
import { decodeJWT } from "../../../utils";
import NewsModal from "../../../helpers/NewsModal/NewsModal";
import ColorChangingIcon from "../../../helpers/ColorChangingIcon/ColorChangingIcon";
import { AiFillNotification } from "react-icons/ai";
import { HiLockOpen, HiLockClosed } from "react-icons/hi";
import { newsAdminContext } from "../../../context/AdminContext/NewsAdminContext/NewsAdminContext";

const PublicPcMenu = () => {
  const [openModal, setOpenModal] = useState(false);
  const token = localStorage.getItem("token");
  const isLogin = !isEmpty(token);
  const roleName = decodeJWT(token)?.usertype;

  const { handleChangeStoreStatus, handleGetStoreStatus, isStoreCloses } =
    useContext(newsAdminContext);

  // در useEffect اضافه کنید
  useEffect(() => {
    if (roleName === "ADMIN") {
      handleGetStoreStatus();
    }
  }, []);

  useEffect(() => {
    setOpenModal(true);
  }, []);

  if (!isLogin) return <Navigate to="/" replace />;

  return (
    <div className="fixed z-10 top-0 pb-3 px-6 w-full lg:flex hidden flex-col justify-between h-screen border-l border-yellow-600 bg-[#171d3f] transition duration-300 md:w-4/12 lg:ml-0 lg:w-[25%] xl:w-[20%] 2xl:w-[15%]">
      {/* Header Section */}
      <div className="flex flex-col items-center pt-6">
        <div className="flex flex-col items-center mb-6">
          <img
            src={logo}
            width={150}
            className="bg-cover mb-2"
            alt="Website Logo"
          />
          <p className="text-white text-lg font-medium">هو الرزاق</p>
        </div>

        <div className="flex justify-between w-full px-4 mb-8">
          <button
            onClick={() => setOpenModal(!openModal)}
            className="p-2 rounded-full hover:bg-[#153477] transition"
          >
            <ColorChangingIcon
              Icon={AiFillNotification}
              size={25}
              className="animate__animated animate__swing animate__slow animate__infinite"
              firstColor="#facc15"
              secondColor="#000"
            />
          </button>

          {roleName === "ADMIN" && (
            <>
              {isStoreCloses === true ? (
                <button
                  onClick={() => handleChangeStoreStatus(false)}
                  className="p-2 rounded-full hover:bg-[#153477] transition"
                  title="فعال کردن فروشگاه"
                >
                  <HiLockClosed size={25} className="text-red-600" />
                </button>
              ) : (
                <button
                  onClick={() => handleChangeStoreStatus(true)}
                  className="p-2 rounded-full hover:bg-[#153477] transition"
                  title="غیرفعال کردن فروشگاه"
                >
                  <HiLockOpen size={25} className="text-green-600" />
                </button>
              )}
            </>
          )}

          <NavLink
            to="/Log-Out"
            className="p-2 rounded-full hover:bg-[#153477] transition"
          >
            <MdOutlinePowerSettingsNew size={25} className="text-yellow-600" />
          </NavLink>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-grow flex flex-col max-h-[90vh] overflow-y-auto scrollbar-thin scrollbar-thumb-yellow-700 scrollbar-track-[#171d3f]">
        <ul className="space-y-3 tracking-wide text-black font-medium">
          {/* عمومی */}
          <li>
            <NavLink
              to="/Public/Home"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                  : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
              }
            >
              <HiOutlineHome size={25} className="ml-2 text-yellow-600" />
              <span className="text-white mr-1">صفحه اصلی</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/Public/Live-Transactions"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                  : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
              }
            >
              <MdOutlineHistoryEdu size={25} className="ml-2 text-yellow-600" />
              <span className="text-white mr-1">معاملات جاری</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/Public/Last-Transactions"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                  : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
              }
            >
              <MdOutlineAccessTime size={25} className="ml-2 text-yellow-600" />
              <span className="text-white mr-1">آخرین معاملات</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/Public/ContactUs"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                  : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
              }
            >
              <MdOutlineContactPhone
                size={25}
                className="ml-2 text-yellow-600"
              />
              <span className="text-white mr-1">تماس با ما</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to={
                roleName === "ADMIN"
                  ? "/Admin/Dashboard/Profile"
                  : "/Customer/Profile"
              }
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                  : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
              }
            >
              <MdOutlinePieChart size={25} className="ml-2 text-yellow-600" />
              <span className="text-white mr-1">
                {roleName === "ADMIN" ? "پنل ادمین" : "پنل کاربری"}
              </span>
            </NavLink>
          </li>

          {/* -------------------- آیتم‌های مخصوص ادمین -------------------- */}
          {roleName === "ADMIN" && (
            <>
              <div className="border-t border-yellow-200 border-opacity-50 my-2"></div>

              <li>
                <NavLink
                  to="/Admin/Dashboard/News"
                  className={({ isActive }) =>
                    isActive
                      ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                      : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
                  }
                >
                  <HiOutlineNewspaper
                    size={25}
                    className="ml-2 text-yellow-600"
                  />
                  <span className="text-white mr-1">اخبار</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/Admin/Dashboard/Requests"
                  className={({ isActive }) =>
                    isActive
                      ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                      : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
                  }
                >
                  <HiExclamation size={25} className="ml-2 text-yellow-600" />
                  <span className="text-white mr-1">درخواست‌ها</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/Admin/Dashboard/Products"
                  className={({ isActive }) =>
                    isActive
                      ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                      : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
                  }
                >
                  <HiOutlineShoppingBag
                    size={25}
                    className="ml-2 text-yellow-600"
                  />
                  <span className="text-white mr-1">محصولات</span>
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/Admin/Dashboard/Users"
                  className={({ isActive }) =>
                    isActive
                      ? "relative px-4 py-3 flex items-center bg-[#173372] rounded-xl border border-yellow-300"
                      : "relative px-4 py-3 flex items-center rounded-xl hover:bg-[#153477]"
                  }
                >
                  <HiOutlineUserGroup
                    size={25}
                    className="ml-2 text-yellow-600"
                  />
                  <span className="text-white mr-1">کاربران</span>
                </NavLink>
              </li>
            </>
          )}

          {/* News Modal */}
          {openModal && (
            <li>
              <NewsModal viewTag="pc" onClose={() => setOpenModal(false)} />
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default PublicPcMenu;
